module.exports = __webpack_public_path__ + "si.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/si.svg
// module id = 1056
// module chunks = 0